import ComponentFactory from './ComponentFactory';
import Icons from './utils/Icons';

class Main {
  constructor() {
    this.init();
  }

  init() {
    document.documentElement.classList.add('has-js');
    new ComponentFactory();
    Icons.load();
    console.log(
      'Salut à toi! Si tu veux bien tester le responsive mobile et tablette de mon site, redimensionne la fenêtre, puis recharge la page ;)'
    );
  }
}

new Main();
